module.exports = __webpack_public_path__ + "images/assets/cd73a592d4d1f1ff6f8275ebc67ca699.svg";